export const environment = {
  production: false,
  // Same endpoints as production by default; point these at the dev stack
  // (and the dev Stytch project) before wiring real tenants.
  apiUrl: 'https://dev.matprim.trueformtechnology.com/uas',
  authApiUrl: 'https://dev.matprim.trueformtechnology.com/ams',
  phsApiUrl: 'https://dev.matprim.trueformtechnology.com/phs',
  dcsApiUrl: 'https://dev.matprim.trueformtechnology.com/dcs',
  pcsApiUrl: 'https://dev.matprim.trueformtechnology.com/pcs',
  authOrganizationId: 'organization-test-d4039fdb-6c7d-47ba-bc26-39a1f3bad8ee',
  authOrganizationName: 'Materias Primas',
  stytchPublicToken: 'public-token-test-629f8347-8605-441e-a9db-a5def7f9639d',
  appHost: 'https://dev.matprim.trueformtechnology.com',
  stytchSessionDurationMinutes: 60,
};
